export default {
  mounted(element, binding) {
    let callback
    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01
    }

    if (typeof binding.value === 'function') {
      callback = binding.value
    }

    if (typeof binding.value === 'object') {
      callback = binding.value.callback

      if (typeof binding.value.intersection === 'object') {
        options = { ...options, ...binding.value.intersection }
      }
    }

    if (!callback) {
      return
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry.isIntersecting, entry)
        }
      })
    }, options)

    observer.observe(element)
    element._observer = observer
  },
  unmounted(element) {
    if (element._observer) {
      element._observer.disconnect()
    }
  }
}
